module.exports = __webpack_public_path__ + "img/cover2.daaaa7d2.png";